import EnvirotainerRules from "./Envirotainer/EnvirotanerRules";
import PT300Rules from "./PT300/PT300Rules";
import Rules from "./Rules";

export const parseRules = (data: any, type: string, deviceId: string): Rules => {
  const deviceType: string = type.toUpperCase() || '';
  switch (deviceType) {
    case 'ENVIROTAINER': {
      return new EnvirotainerRules(data, deviceId);
    }
    case 'PT300D':
    case 'PT300': {
      return new PT300Rules(data);
    }
    default:
      return new EnvirotainerRules(data, deviceId);
  }
}
